import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StatusBar, Style } from '@capacitor/status-bar';
import { AuthService } from './services/auth.service';
import { AnnouncementService } from './services/announcement.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AnnouncementComponent } from './components/common/announcement/announcement.component';
import { Capacitor } from '@capacitor/core';
import { ActionPerformed, PushNotifications, PushNotificationSchema, Token } from '@capacitor/push-notifications';
import { PushService } from './services/push.service';
import { Platform } from '@ionic/angular';
import { Keyboard } from '@capacitor/keyboard';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  pushListenersInitialized = false;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private modalService: NgbModal,
    private announcementService: AnnouncementService,
    private pushService: PushService,
    private platform: Platform
  ) { }

  ngOnInit() {
    //document.documentElement.setAttribute('dir', 'rtl');
    //document.documentElement.setAttribute('lang', 'ar'); 

    this.statusBarPadding()

    if (Capacitor.isNativePlatform()) {
      this.platform.ready().then(async () => {
        await StatusBar.show();
        await StatusBar.setBackgroundColor({ color: '#4ba0e8' });
        await StatusBar.setStyle({ style: Style.Dark });
      });
    }

    this.authService.isSignedIn().subscribe((result) => {
      if (result.signed_in) {
        if (Capacitor.getPlatform() != 'web') {
          PushNotifications.requestPermissions().then(result => {
            if (result.receive === 'granted') {
              PushNotifications.register().then(() => { });
            }
          })
        }
      }
    })

    if (!this.pushListenersInitialized && Capacitor.getPlatform() != 'web') {
      this.pushListenersInitialized = true

      PushNotifications.addListener('registration',
        (token: Token) => {
          this.authService.isSignedIn().subscribe((result) => {
            if (result.signed_in) {
              this.pushService.registerToken(token.value).subscribe((data) => { })
            }
          })

          if (Capacitor.getPlatform() == 'android') {
            PushNotifications.createChannel({
              id: 'Messages',
              name: 'Messages',
              importance: 5,
            })
          }
        });

      PushNotifications.addListener('registrationError',
        (error: any) => {
          alert('Error on registration: ' + JSON.stringify(error));
        }
      )

      PushNotifications.addListener('pushNotificationReceived',
        (notification: PushNotificationSchema) => {
          //alert('Push received: ' + JSON.stringify(notification));
        }
      );


      PushNotifications.addListener('pushNotificationActionPerformed',
        (notification: ActionPerformed) => {
          let data = notification.notification.data && notification.notification.data.data ? JSON.parse(notification.notification.data.data) : null

          if (data && data.shift_id) {
            this.router.navigate(['/shifts', data.shift_id])
          }

          else {
            this.router.navigate(['/chat'])
          }
        }
      );
    }

    this.getAnnouncements()
  }

  getAnnouncements() {
    this.announcementService.forPlacement('app_start').subscribe(announcements => {
      for (let announcement of announcements) {
        const modal = this.modalService.open(AnnouncementComponent, {
          windowClass: 'announcement-modal',
          keyboard: true,
          animation: true,
        })

        modal.componentInstance.announcement = announcement
      }
    })
  }

  statusBarPadding() {
    let paddingValue = '0px';
    let keyboardOffset = '0px';

    const userAgent = navigator.userAgent || navigator.vendor;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);
    const isMobile = /Mobi|Android/i.test(userAgent);
    const isCapacitor = Capacitor.isNativePlatform();

    if (isIOS && isCapacitor) {
      // iOS → StatusBar usually ~24px safe area
      //paddingValue = '24px';
    } else if (isAndroid && isCapacitor) {
      paddingValue = '24px';
    }

    document.documentElement.style.setProperty('--statusbar-padding', paddingValue);

    // Setup keyboard listeners — only if Capacitor on Android
    if (isAndroid && isCapacitor) {
      Keyboard.addListener('keyboardWillShow', info => {
        keyboardOffset = `${info.keyboardHeight}px`;
        document.documentElement.style.setProperty('--keyboard-offset', keyboardOffset);
      });

      Keyboard.addListener('keyboardWillHide', () => {
        keyboardOffset = '0px';
        document.documentElement.style.setProperty('--keyboard-offset', keyboardOffset);
      });
    } else {
      // For web fallback — set keyboard offset to 0
      document.documentElement.style.setProperty('--keyboard-offset', '0px');
    }
  }
}

// Utility function
function isIOSBrowser() {
  return /iP(ad|hone|od)/.test(navigator.userAgent) && Capacitor.getPlatform() === 'web';
}

function updateVhUnit() {
  const platform = Capacitor.getPlatform();

  const isIOS = (platform === 'ios') || isIOSBrowser();

  // On iOS, visualViewport.height causes shrink bug → use innerHeight instead
  const vh = isIOS
    ? window.innerHeight * 0.01
    : (window.visualViewport
      ? window.visualViewport.height * 0.01
      : window.innerHeight * 0.01);

  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // Optional: log for debug
  // console.log(`updateVhUnit: platform=${platform} isIOS=${isIOS} vh=${vh * 100}px`);
}

// Call once now
updateVhUnit();

// Listen to resize and orientation change
window.addEventListener('resize', updateVhUnit);
window.addEventListener('orientationchange', updateVhUnit);

// Optional (rare case fix): some Samsung keyboards fire 'focus'/'blur' without resize → you can also listen to 'focusin'/'focusout' if needed
// window.addEventListener('focusin', updateVhUnit);
// window.addEventListener('focusout', updateVhUnit);